import React, { Suspense, Fragment, useEffect, useState } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import "./App.scss";
import Layout from "../src/components/Layout";
import LoggedoutLayout from "../src/components/LoggedoutLayout";
import TemplateLayout from "../src/components/TemplateLayout";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../src/utils/AppInsights";
import Loader from "../src/components/Common/Loader";
import { utils } from "utils/Utils";


import '../src/Styles/panel.menus.css'
import { useDispatch, useSelector } from 'react-redux'
import {
     TokenGenerate,
} from '../src/components/Slice/Token'
import DesignServicePage from "components/Plan/DesignServicePage";
import LayoutWithoutToggle from "components/LayoutWithoutToggle";
import UpdateStyle from "components/Style/UpdateStyle";



const StyleList = React.lazy(() =>
     import("../src/components/Style/StyleList")
);
const Domain = React.lazy(() =>
     import("../src/components/Domain/Purchased")
);
const SearchDomain = React.lazy(() =>
     import("../src/components/Domain/Search")
);
const Checkout = React.lazy(() =>
     import("../src/components/Domain/Checkout")
);
const Usedomain = React.lazy(() =>
     import("../src/components/Domain/UseDomain")
);
const GeneralSetting = React.lazy(() =>
     import("./components/Generalsettings/GeneralSettings")
);
const ChangeStyle = React.lazy(() =>
     import("../src/components/Style/ChangeStyle")
);

const WebDesigner = React.lazy(() =>
     import("../src/components/WebDesigner/WebDesignerManager.tsx")
);
const WindowedPreview = React.lazy(() =>
     import("../src/components/WebDesigner/WindowedPreview.tsx")
);

const LoggedOut = React.lazy(() =>
     import("./Layout/LoggedOut")
);

const SetLibrary = React.lazy(() =>
     import("../src/components/SetLibrary/SetLibraryMenu")
);

const ThemeList = React.lazy(() =>
     import("../src/components/SetLibrary/ThemeOrStyleRouter")
);

const BuildYourOwnSetMenu = React.lazy(() =>   import("../src/components/SetLibrary/BuildYourOwnSetMenu")
);

const Multilocation = React.lazy(() =>
     import("./components/Multilocation/Multilocation")
);

//import LoggedOut from "./Layout/LoggedOut";

const App = () => {

     const [isandroidiospro, setisandroidiospro] = useState();
     const dispatch = useDispatch();
     const { generate_time, access_token } = useSelector((state) => state.Token);
     useEffect(() => {
          utils.CheckIsFromProApp(setisandroidiospro);
          GetToken();
     }, []);

     const GetToken = async () => {
          if (typeof generate_time == "undefined" ||
               generate_time == null ||
               generate_time == "" || Date.parse(new Date()) > generate_time) {
               await dispatch(TokenGenerate());
          }
     }

     
     return (
          typeof access_token != "undefined" &&
          access_token != null &&
          access_token != "" &&
          <AppInsightsContext.Provider value={reactPlugin}>

               <Suspense fallback={<Loader isgrid={false} />}>
                    <Fragment>
                         <Routes>
                              <Route path="/" element={<Layout />}>
                                   {["/", "/admin/:EncryptCode"].map((path) => (
                                        <Route key={path} path={path} element={<ThemeList />} />
                                   ))}       
                                    {["admin/setlibrary"].map((path) => (
                                        <Route key={path} path={path} element={<SetLibrary />} />
                                   ))}

                                    {["admin/stylelist"].map((path) => (
                                        <Route key={path} path={path} element={<StyleList />} />
                                   ))}      
                                                                               
                              </Route>

                              
                              <Route path="/" element={<LayoutWithoutToggle />}>
                                   {["admin/designservicepage"].map((path) => (
                                        <Route key={path} path={path} element={<DesignServicePage />} />
                                   ))}
                                   {[":admin/:StyleId/:LayoutId/changestyle", ":business/:StyleId/:LayoutId/changestyle"].map((path) => (
                                        <Route key={path} path={path} element={<ChangeStyle />} />
                                   ))}
                                    {[":business/:StyleId/:LayoutId/domain", ":admin/:StyleId/:LayoutId/domain"].map((path) => (
                                        <Route key={path} path={path} element={<Domain />} />
                                   ))}
          
                                   {[":business/:StyleId/:LayoutId/usedomain", ":admin/:StyleId/:LayoutId/usedomain"].map((path) => (
                                        <Route key={path} path={path} element={<Usedomain />} />
                                   ))}
                                   {[":admin/:StyleId/:LayoutId/searchdomain", ":admin/:StyleId/:LayoutId/searchdomain/:domainname", ":business/:templateid/searchdomain", ":business/:templateid/searchdomain/:domainname"].map((path) => (
                                        <Route key={path} path={path} element={<SearchDomain />} />
                                   ))}
                                   {[":admin/:StyleId/:LayoutId/checkout", ":admin/:StyleId/:LayoutId/checkout/:domainname", ":business/:templateid/checkout", ":business/:templateid/checkout/:domainname"].map((path) => (
                                        <Route key={path} path={path} element={<Checkout />} />
                                   ))}
                                   {[":admin/:StyleId/:LayoutId/generalsetting", ":business/:StyleId/:LayoutId/generalsetting"].map((path) => (
                                        <Route key={path} path={path} element={<GeneralSetting />} />
                                   ))}           
                                   {[":business/:StyleId/:LayoutId/changelayout"].map((path) => (
                                        <Route key={path} path={path} element={<><UpdateStyle /> </>} />
                                   ))}
                                   {[":admin/:StyleId/:LayoutId/multilocation", ":business/:StyleId/:LayoutId/multilocation"].map((path) => (
                                        <Route key={path} path={path} element={<Multilocation Mode={1} dispatch={dispatch} />} />
                                   ))}           
                              </Route>
                              <Route path="/" element={<TemplateLayout />}>
                                   {[":admin/:StyleId/:LayoutId/designer", ":business/:StyleId/:LayoutId/designer"].map((path) => (
                                        <Route
                                             key={path}
                                             path={path}
                                             isWebbuilderHeader={true}
                                             element={
                                                  <WebDesigner
                                                       isProApp={true}
                                                       layout={null}
                                                       dispatch={dispatch}
                                                  />
                                             }
                                        />
                                   ))}
                              </Route>
                              <Route path="/" element={<LoggedoutLayout />}>
                                   <Route
                                        path="/loggedout"
                                        element={
                                             <LoggedOut />
                                        }
                                   />
                              </Route>
                              <Route path="*" element={<Layout />} />
                         </Routes>
                    </Fragment>
               </Suspense>
          </AppInsightsContext.Provider>
     );
};

export default App;